import * as React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { useLockBodyScroll } from '../../hooks/useLockBodyScroll';
import { useStickyHeader } from '../../hooks/useStickyHeader';
export var PageHeader = function (_a) {
    var _b = _a.logo, logo = _b === void 0 ? React.createElement(Logo, null) : _b, _c = _a.home, home = _c === void 0 ? '/' : _c, children = _a.children;
    var _d = React.useState(false), open = _d[0], setOpen = _d[1];
    var header = useStickyHeader();
    useLockBodyScroll(open);
    return (React.createElement("header", { ref: header, "data-open": open },
        React.createElement("nav", { className: "container row", onClick: function () { return open && setOpen(false); } },
            React.createElement("div", { className: "row header-brand" },
                React.createElement(Link, { to: home, className: "navbar-brand" }, logo),
                React.createElement("div", { className: "navbar-toggler" },
                    React.createElement("button", { onClick: function () { return setOpen(!open); }, type: "button", "data-toggle": "collapse", "aria-controls": "navbar-menu-content", "aria-expanded": open, "aria-label": "Toggle navigation" },
                        React.createElement("i", { className: "fas fa-bars" })))),
            children)));
};
//# sourceMappingURL=PageHeader.js.map